import DaumPostcode from 'react-daum-postcode';
import styled from 'styled-components';

const Postcode = props => {
  const handleComplete = data => {
    const fullAdderss = data.address;
    props.closeModal();
    props.setLocalStore(fullAdderss);
  };

  return (
    <PostcodeBlock>
      <DaumPostcode onComplete={handleComplete} {...props} />
    </PostcodeBlock>
  );
};

export default Postcode;

const PostcodeBlock = styled.div`
  width: 480px;
`;
